import * as _ from "lodash";
import ExternalLogger from "../../../ExternalLogger";

var SamlTokenService = function ($q, $state, $timeout, accountService, samlTokenFactory) {
    var logger = ExternalLogger.getInstance("SamlTokenService");

    var service = this;

    //This formats the SAML Response to fit the POST url's requirements.
    function filterSamlData(samlResponse) {
        return (samlResponse.replace ? samlResponse : "").replace(/\\n/g, "\n");
    }

    //This calls the factory to get the SAML Token.
    function getMySamlToken(factoryName) {
        var deferred = $q.defer();
        accountService.setActiveGroupAccount().then((params) => {
            console.log("get my saml token - params", params, "factory", factoryName);

            //If a facotryName is not passed, use the access portal's description.
            if (!factoryName) {
                console.log("set provider url and phone number");
                accountService.setProviderUrlAndPhoneNumberObject().then(
                    function () {
                        factoryName =
                            accountService.urlPhoneNumberData.accessPortalsDTO.accessPortals[0]
                                .descr;
                        var factoryMethod = "get" + factoryName + "SamlToken";
                        samlTokenFactory[factoryMethod].query(
                            params,
                            function (data) {
                                data.factoryName = factoryName;
                                deferred.resolve(data);
                            },
                            function (response) {
                                deferred.reject();
                            }
                        );
                        return deferred.promise;
                    },
                    function (err) {
                        console.log(err);
                        vm.accountOverviewTRSError = true;
                        vm.accountOverviewTRSLoaded = true;
                    }
                );
            } else {
                console.log("call saml token factory", factoryMethod);
                var factoryMethod = "get" + factoryName + "SamlToken";
                samlTokenFactory[factoryMethod].query(
                    params,
                    function (data) {
                        data.factoryName = factoryName;
                        deferred.resolve(data);
                    },
                    function (response) {
                        deferred.reject();
                    }
                );
            }
        });
        return deferred.promise;
    }

    //This takes the generated SAMLResponse and/or any additional parameters,
    //and populates a hidden form in the view, then submits it to the provider's web site.
    var getMySamlTokenResult = function (data, ssoWindow, uniqueId) {
        var deferred = $q.defer();
        logger.info("getMySamlTokenResult()");
        let samlResponse = document.createElement("input");
        let relayState = document.createElement("input");
        let ssoIndicator = document.createElement("input");
        let lowerCaseId = document.createElement("input");

        Object.assign(samlResponse, {
            id: "SAMLResponse",
            type: "hidden",
            name: "SAMLResponse"
        });
        Object.assign(relayState, {
            id: "RelayState",
            type: "hidden",
            name: "RelayState"
        });
        Object.assign(ssoIndicator, {
            id: "SSOIndicator",
            type: "hidden",
            name: "SSOIndicator"
        });
        Object.assign(lowerCaseId, {
            type: "hidden"
        });

        document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("action", data.postUrl);
        _.forOwn(data, function (value, key) {
            if (
                key !== "$promise" &&
                key !== "$resolved" &&
                key !== "factoryName" &&
                key.toLowerCase() !== "posturl"
            ) {
                if (key.toLowerCase() === "samlresponse") {
                    samlResponse.setAttribute("value", value);
                    document.getElementById("SAMLResponse")?.remove();
                    document.getElementById(`SAMLFORM${uniqueId}`).append(samlResponse);
                } else if (key.toLowerCase() === "relaystate") {
                    relayState.setAttribute("value", value);
                    document.getElementById("RelayState")?.remove();
                    document.getElementById(`SAMLFORM${uniqueId}`).append(relayState);
                } else if (key.toLowerCase() === "ssoindicator") {
                    ssoIndicator.setAttribute("value", value);
                    document.getElementById("SSOIndicator")?.remove();
                    document.getElementById(`SAMLFORM${uniqueId}`).append(ssoIndicator);
                } else {
                    lowerCaseId.setAttribute("value", value);
                    lowerCaseId.setAttribute("id", key.toLowerCase());
                    lowerCaseId.setAttribute("name", key);
                    document.getElementById(key.toLowerCase())?.remove();
                    document.getElementById(`SAMLFORM${uniqueId}`).append(lowerCaseId);
                }
            }
        });

        if (data.factoryName === "Milliman") {
            document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("method", "GET");
        } else {
            document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("method", "POST");
        }

        if (uniqueId == "Candidly") {
            document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("target", "_self");
        } else {
            document.querySelector(`#SAMLFORM${uniqueId}`).setAttribute("target", "ssoWindow");
        }

        if (!ssoWindow || ssoWindow.closed || typeof ssoWindow.closed === "undefined") {
            alert(
                "Please allow popups from empower-retirement.com in order to view the provider's website."
            );
            deferred.reject();
        }
        if (!ssoWindow) {
            var errorMessage = "There was an error launching the provider website.";
            if (!ssoWindow || ssoWindow.closed || typeof ssoWindow.closed == "undefined") {
                errorMessage +=
                    " Please allow popups from empower-retirement.com in order to view the provider's website.";
            }
            alert(errorMessage);
            deferred.reject();
        }
        var ssoWindowLoaded = false;

        if (ssoWindow) {
            document.querySelector(`#SAMLFORM${uniqueId}`).submit();
            ssoWindowLoaded = true;
            $q.when();
        }
        // var ssoWindowLoaded = false;
        // console.log("samltokenService",ssoWindow.document,ssoWindow.document.readyState)
        // if (ssoWindow) {
        //     document.querySelector(`#SAMLFORM${uniqueId}`).submit();
        //     ssoWindowLoaded = true;
        //     console.log("complete submit")
        //     deferred.resolve();
        // } else {
        //     console.log("no window")
        //     deferred.reject()
        // }

        // $timeout(function () {
        //     if (!ssoWindowLoaded) {
        //         var errorMessage = "There was an error launching the provider website.";
        //         if (!ssoWindow || ssoWindow.closed || typeof ssoWindow.closed == "undefined") {
        //             errorMessage +=
        //                 " Please allow popups from empower-retirement.com in order to view the provider's website.";
        //         }
        //         alert(errorMessage);
        //         deferred.reject();
        //     }
        // }, 6000);

        return deferred.promise;
    };

    //This is the main function to be used in Controllers and Directives.
    service.navigateToken = function (factoryName, ssoWindow, uniqueId) {
        var deferred = $q.defer();
        logger.info("navigateToken()");

        var getMySamlTokenFault = function () {
            logger.info("getMySamlTokenFault()");
        };

        getMySamlToken(factoryName)
            .then(function success(data) {
                return getMySamlTokenResult(data, ssoWindow, uniqueId);
            })
            .then(deferred.resolve)
            .catch(getMySamlTokenFault);

        return deferred.promise;
    };

    //This service returns a promise for whether Total Rewards should show.
    service.showTotalRewardsPromise = function () {
        var deferred = $q.defer();

        samlTokenFactory.showTotalRewards.query(
            function (result) {
                deferred.resolve(result);
            },
            function (response) {
                deferred.reject();
            }
        );

        return deferred.promise;
    };
};

SamlTokenService.$inject = ["$q", "$state", "$timeout", "accountService", "samlTokenFactory"];
export default SamlTokenService;
